module.exports = __webpack_public_path__ + "static/media/temp_38.95594614.jpg";